/**
 * Updates the login status for GTM to conditionally fire Facebook Pixel events
 * @param {boolean} isLoggedIn
 */

const updateLoginStatus = (isLoggedIn) => {
  window.isLoggedIn = isLoggedIn;

  if (window.dataLayer) {
    window.dataLayer.push({
      event: "user_login_status_changed",
      isLoggedIn,
    });
  }
};

export default updateLoginStatus;
